module.exports = __webpack_public_path__ + "static/media/press.8763ee9f.svg";